"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Separator = _interopRequireDefault(require("./Separator"));
var _NavMenuItem = _interopRequireDefault(require("./NavMenuItem"));
var _MenuItem = _interopRequireDefault(require("./MenuItem"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
const StyledMenu = _styledComponents.default.ul.withConfig({
  displayName: "Menu__StyledMenu",
  componentId: "sc-14wip9p-0"
})(["list-style:none;margin:0;padding:10px;"]);
const defaultRender = data => {
  const {
    splitter,
    path,
    ...props
  } = data;
  if (splitter) {
    return /*#__PURE__*/_react.default.createElement(_Separator.default, {
      paddingVertical: "small",
      color: "background400"
    });
  }
  if (path) {
    return /*#__PURE__*/_react.default.createElement(_NavMenuItem.default, _extends({
      path: path
    }, props));
  }
  return /*#__PURE__*/_react.default.createElement(_MenuItem.default, props);
};
const Menu = ({
  data,
  render,
  ...props
}) => /*#__PURE__*/_react.default.createElement(StyledMenu, props, data.map((d, index) => /*#__PURE__*/_react.default.createElement("li", {
  key: index.toString()
}, render(d, index))));
Menu.propTypes = {
  data: _propTypes.default.arrayOf(_propTypes.default.shape({})),
  render: _propTypes.default.func
};
Menu.defaultProps = {
  data: [],
  render: defaultRender
};
const _default = Menu;
var _default2 = exports.default = _default;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(StyledMenu, "StyledMenu", "/Users/jake.clayton/frontend/ls-common-client/src/components/Menu.js");
  reactHotLoader.register(defaultRender, "defaultRender", "/Users/jake.clayton/frontend/ls-common-client/src/components/Menu.js");
  reactHotLoader.register(Menu, "Menu", "/Users/jake.clayton/frontend/ls-common-client/src/components/Menu.js");
  reactHotLoader.register(_default, "default", "/Users/jake.clayton/frontend/ls-common-client/src/components/Menu.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();